import { defineStore } from "pinia";

export const useModelDetail = defineStore("modelDetail", {
  state: () => ({
    modelOneDetail: {},
    modelTwoDetail: {},
  }),
  getters: {
    getModelOneDetail(state) {
      return state.modelOneDetail;
    },
    getModelTwoDetail(state) {
      return state.modelTwoDetail;
    },
  },
  actions: {
    setModelOneDetail(e) {
      this.modelOneDetail = e;
    },
    setModelTwoDetail(e) {
      this.modelTwoDetail = e;
    },
    deleteModels() {
      this.modelOneDetail = {};
      this.modelTwoDetail = {};
    },
  },
});
